// extracted by mini-css-extract-plugin
export default {"departments":"bF-z","departmentHeading":"cF-z","departmentSection":"dF-z","departmentName":"eF-z","departmentLink":"fF-z","expandIcon":"gF-z"};